import { useRegister } from "./RegisterContext";
import AthleteVerification from "./AthleteVerification";
import { useConfirmModal } from "../../components/reusable/ConfirmModalContext";
import Elips from "../../components/reusable/Elips";
import RegisterSuccessModal from "./RegisterSuccessModal";
import ClubVerification from "./ClubVerification";
import StaffVerification from "./StaffVerification";
import LawyerVerification from "./LawyerVerification";
import MediaVerification from "./MediaVerification";
import BrandVerification from "./BrandVerification";
import FanVerification from "./FanVerification";
import EmailVerificationModal from "./EmailVerificationModal";
import { useTranslation } from "react-i18next";


export default function RegisterStep3() {

    const { openConfirmModal } = useConfirmModal();

    const { t } = useTranslation();

    const {

        step,
        profile,
        prev,

        sendVerificationCode,

        loading,

        showSuccessModal,
        setShowSuccessModal,

        emailVerificationOpen,
        emailCode,
        setEmailCode,

        verifyEmailCode,

        verificationError,
        pendingRegister,

        formData,

        setVerificationError,
        validateVerificationFiles,
        verificationFilesError

    } = useRegister();


    if (step !== 3)
        return null;


    const renderVerification = () => {

        switch (profile) {

            case "athlete":
                return <AthleteVerification />;

            case "club":
                return <ClubVerification />;

            case "staff":
                return <StaffVerification />;

            case "lawyer":
                return <LawyerVerification />;

            case "media":
                return <MediaVerification />;

            case "brand":
                return <BrandVerification />;

            case "fan":
                return <FanVerification />;

            default:
                return (
                    <div>
                        {t("registerStep3.comingSoon")}
                    </div>

                );
        }
    };

    return (

        <div className={`register-step register-step--verification register-animate ${verificationFilesError ? "verification-upload-error" : ""}`}>

            <h2>
                {t("registerStep3.title")}
            </h2>

            {renderVerification()}

            {verificationFilesError && (
                <div className="verification-upload-alert" role="alert" aria-live="assertive">
                    <span aria-hidden="true">!</span>
                    <div>
                        <strong>{t("registerErrors.uploadRequiredTitle")}</strong>
                        <p>{t("registerErrors.uploadRequiredFiles")}</p>
                    </div>
                </div>
            )}

            <div className="register-actions">
                <button
                    type="button"
                    className="register-secondary-btn"
                    onClick={prev}
                >
                    {t("registerStep3.back")}
                </button>

                <button
                    className="register-primary-btn"
                    disabled={loading}
                    onClick={() => {
                        if (!validateVerificationFiles()) return;

                        openConfirmModal({

                            title:
                                t(
                                    "registerStep3.confirmTitle"
                                ),

                            message:
                                t(
                                    "registerStep3.confirmMessage"
                                ),

                            confirmText:
                                loading
                                    ?
                                    t(
                                        "registerStep3.creating"
                                    )
                                    :
                                    t(
                                        "registerStep3.continue"
                                    ),
                            onConfirm:
                                sendVerificationCode
                        });
                    }}
                >
                    {loading
                        ?
                        <Elips />
                        :
                        t(
                            "registerStep3.createAccount"
                        )
                    }
                </button>
            </div>

            <EmailVerificationModal

                emailVerificationOpen={
                    emailVerificationOpen
                }

                emailCode={
                    emailCode
                }

                setEmailCode={
                    setEmailCode
                }

                verifyEmailCode={
                    verifyEmailCode
                }

                verificationError={
                    verificationError
                }

                pendingRegister={
                    pendingRegister
                }

                email={
                    formData.email
                }

                setVerificationError={
                    setVerificationError
                }
            />
            {showSuccessModal && (

                <RegisterSuccessModal

                    onClose={() =>
                        setShowSuccessModal(
                            false
                        )
                    }
                />
            )}
        </div>
    );
}
